import request from '@/utils/request'

let activityApi = {
  /*活动列表*/
  activityList(data, errorback) {
    return request._post('/shop/plus.activity.Activity/index', data, errorback);
  },
  /*添加活动*/
  addActivity(data, errorback) {
    return request._post('/shop/plus.activity.Activity/add', data, errorback);
  },
  // 活动退款申请-通过
  passCanel(data, errorback) {
    return request._post('/shop/plus.activity.Activity/passCanel', data, errorback);
  },
  /*获取活动数据*/
  getActivity(data, errorback) {
    return request._get('/shop/plus.activity.Activity/edit', data, errorback);
  },
  /*保存活动*/
  editActivity(data, errorback) {
    return request._post('/shop/plus.activity.Activity/edit', data, errorback);
  },
  /*删除店员*/
  delActivity(data, errorback) {
    return request._post('/shop/plus.activity.Activity/delete', data, errorback);
  },
  saveSetting(data, errorback) {
    return request._post('/shop/plus.activity.Setting/getSetting', data, errorback);
  },
  getSetting(data, errorback) {
    return request._get('/shop/plus.activity.Setting/getSetting', data, errorback);
  },

  detail(data,errorback){
    return request._get('/shop/plus.activity.Activity/detail',data,errorback);
  },
  getIdentity(data,errorback){
    return request._get('/shop/plus.activity.Activity/getIdentity',data,errorback);
  },
  /*店员列表*/
  clerklist(data, errorback) {
    return request._post('/shop/plus.activity.Clerk/index', data, errorback);
  },
  /*店员添加*/
  addClerk(data, errorback) {
    return request._post('/shop/plus.activity.Clerk/add', data, errorback);
  },
  /*店员详情*/
  clerkDetail(data, errorback) {
    return request._get('/shop/plus.activity.Clerk/edit', data, errorback);
  },
  /*店员编辑*/
  editClerk(data, errorback) {
    return request._post('/shop/plus.activity.Clerk/edit', data, errorback);
  },
  /*删除店员*/
  deleteClerk(data, errorback) {
    return request._post('/shop/plus.activity.Clerk/delete', data, errorback);
  },
  /* 浏览记录 */
  browseRecord(data, errorback) {
    return request._post('/shop/plus.activity.Activity/browse', data, errorback);
  },
  
}
export default activityApi;



// WEBPACK FOOTER //
// ./src/api/activity.js